export const sqlKeywords = [
  'select',
  'from',
  'where',
  'and',
  'or',
  'group',
  'by',
  'order',
  'limit',
  'offset',
  'having',
  'as',
  'case',
  'when',
  'then',
  'else',
  'end',
  'type',
  'left',
  'right',
  'join',
  'on',
  'outer',
  'desc',
  'asc',
  'union',
  'primary',
  'key',
  'if',
  'foreign',
  'not',
  'references',
  'default',
  'null',
  'inner',
  'cross',
  'natural',
  'database',
  'distinct',
];

export const sqlContants = ['true', 'false'];

export const sqlBuildInFunctions = [
  'avg',
  'count',
  'first',
  'last',
  'max',
  'min',
  'sum',
  'ucase',
  'lcase',
  'mid',
  'len',
  'round',
  'rank',
  'now',
  'format',
  'coalesce',
  'ifnull',
  'isnull',
  'nvl',
];

export const sqlDataTypes = [
  'int',
  'numeric',
  'decimal',
  'date',
  'varchar',
  'char',
  'bigint',
  'float',
  'double',
  'bit',
  'binary',
  'text',
  'set',
  'timestamp',
  'money',
  'real',
  'number',
  'integer',
];
export const VALID = 'valid';
export const INVALID = 'invalid';
export const INTERVAL_LIMIT = 90000;
export const INTERVAL = 10000;
export const VALIDATING = 'validating';

export const UPDATE = 'UPDATE';
export const CREATE = 'CREATE';
export const EDIT_VALIDATE = 'EDIT_VALIDATE';
export const RUN_VALIDATE = 'RUN_VALIDATE';
export const VALIDATE = 'VALIDATE';
export const DELETE = 'DELETE';

export const LINE_GRAPH = 'ChartLineCustom';
export const STATUS_LABEL = 'StatusLabel';

export const NAME_FIELD_REGEX = '^[-_a-zA-Z0-9 ]+$';

export const LINEGRAPH = 'LG';
export const LABEL = 'LB';

export const NEW = 'new';

export const METER_CUSTOM_DB_QUERIES = 'meter_custom_db_queries';

export const DELETE_MENU_KEY = 'DELETE';
export const RUN_MENU_KEY = 'RUN';
export const EDIT_MENU_KEY = 'EDIT';
export const ADD_WIDGET_MENU_KEY = 'ADD_WIDGET';
export const ALERT_MENU_KEY = 'ALERT';
